module.exports = "/_next/static/images/OrchestrateTheOutcomes-3a93521bbca3b7d287b0aa4fa48155cb.webp";